export default __webpack_public_path__ + "static/media/choosing_the_parameters_3.eb6407ab.png";